<template>
	<div class="notifications">
		<div class="alert alert-dismissible fade show"  :class="notification.class" v-for="(notification, index) in busNotifications.notificationData" :key="index">
			<font-awesome-icon :icon="['fal', notification.icon ]" />  {{ notification.msg }}
			<button type="button" class="close"  @click.prevent="busNotifications.closeNotification(index)">
				<font-awesome-icon :icon="['fal', 'times']" />
			</button>
		</div>
	</div>
</template>

<script>
	import { busNotifications } from '../bus.js'

	export default{
		data(){
			return {
				busNotifications: busNotifications
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Notifications.vue